<template>
  <div class="container">
    <form v-on:keyup.enter="search()" v-on:submit.prevent>
        <div class="flex flex-row py-4 gap-10">
          <model-select
              class="form-select"
              :options="metallTypes"
              v-model="metallType"
              placeholder="Тип металлолома"
          ></model-select>
          <model-select
              class="form-select"
              :options="categories"
              v-model="category"
              placeholder="Категория металлолома"
          ></model-select>
          <model-select
              class="form-select"
              :options="years"
              v-model="year"
              placeholder="Год"
          ></model-select>
          <model-select
              class="form-select"
              :options="methods"
              v-model="method"
              placeholder="Способ реализации"
          ></model-select>

          <button
              class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
              @click="search()"
          >
            Поиск
          </button>
          <button
              class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
              @click="clear()"
          >
            Очистить
          </button>
        </div>
      </form>
      <table class="table-auto text-base border border-collapse text-center mx-auto report-table">
        <thead class="border-b bg-gray-50">
          <tr>
            <th class="text-sm font-medium text-gray-900 px-6 py-2 border-r">
              №
            </th>
            <th class="text-sm font-medium text-gray-900 px-6 py-2 border-r">
              Виды металлолома
            </th>
            <th class="text-sm font-medium text-gray-900 px-6 py-2 border-r">
              Категория металлолома
            </th>
            <th class="text-sm font-medium text-gray-900 px-6 py-2 border-r">
              Единица измерения
            </th>
            <th class="text-sm font-medium text-gray-900 px-6 py-2 border-r">
              Способ реализации
            </th>
            <th class="text-sm font-medium text-gray-900 px-6 py-2 border-r">
              Объем
            </th>
            <th class="text-sm font-medium text-gray-900 px-6 py-2 border-r">
              Цена за единицу, тенге
            </th>
            <th class="text-sm font-medium text-gray-900 px-6 py-2 border-r">
              Год реализации
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in reportRows" :key="index">
            <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r border-b">{{ defineIndex(index) }}</td>
            <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r border-b">{{ item.request.is_color ? 'Цветной' : 'Черный' }}</td>
            <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r border-b">{{ item.request.category }}</td>
            <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r border-b">T</td>
            <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r border-b">{{ item.contr_method }}</td>
            <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r border-b">{{ item.contr_count | getNumberFormat }}</td>
            <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r border-b">{{ item.contr_unit_price | getNumberFormat }}</td>
            <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r border-b">{{ getYear(item.contr_date) }}</td>
          </tr>
        </tbody>
      </table>
<!--      <div class="empty-tr" v-if="reportRows.length == 0">-->
<!--        Выберите необходимые фильтры-->
<!--      </div>-->

      <div class="report__pagination">
        <pagination v-if="this.pageCount > 1" :currentPage="this.page" :pageCount="this.pageCount" @pageClicked="search" />
      </div>
  </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select';
import axios from "axios";
import store from "@/store";
import NProgress from "nprogress";
import Pagination from '../../components/shared/Pagination.vue';
import dayjs from 'dayjs'
  export default {
    components: {
      ModelSelect,
      Pagination
    },
    data() {
      return {
        metallTypes: [
          {
            value: 'black',
            text: 'Черный'
          },
          {
            value: 'multicolor',
            text: 'Цветной'
          },
        ],
        metallType: '',
        year: '',
        method: '',
        years: [
          { value: 2021, text: '2021' },
          { value: 2022, text: '2022' },
          { value: 2023, text: '2023' },
          { value: 2024, text: '2024' },
          { value: 2025, text: '2025' },
          { value: 2026, text: '2026' },
          { value: 'all', text: 'Все года' },
        ],
        methods: [
          { value: 1, text: 'Аукцион' },
          { value: 2, text: 'Товарная биржа' },
          { value: 3, text: 'Прямая адресная продажа' }
        ],
        categories: [],
        category: '',
        page: 1,
        reportRows: [],
        pageCount: 1
      }
    },
    computed: {
      getYear(date) {
        return date => dayjs(date).format('YYYY')
      }
    },
    watch: {
      metallType: {
        handler: 'getCategories',
        immediate: true
      }
    },
    methods: {
      defineIndex(index) {
        if (this.page == 1) {
          return index + 1
        } else {
          if (index == 9) {
            return `${this.page}0`
          } else {
            return `${this.page - 1}${index + 1}`
          }
        }
      },
      search(page = 1) {
        this.page = page

        let method;
        if (this.method == 1) {
          method = 'Аукцион'
        } else if (this.method == 2) {
          method = 'Товарная биржа'
        } else if (this.method == 3) {
          method = 'Прямая адресная продажа'
        }


        let payload = {
          year: this.year,
          contr_method: method,
          metal_type: this.metallType,
          category: this.category,
          page: page
        }

        console.log(payload)


        if (this.year) {
          axios
              .get('/report/main_view_report/', {
                params: payload
              })
              .then(response => {
                console.log(response.data);
                this.pageCount = response.data.num_pages;
                this.reportRows = response.data.results
              })
              .then(response => {
                store.dispatch('addNotification', {
                  type: 'success',
                  message: 'Таблица обновлена',
                });
                NProgress.done();
              })
              .catch(e => {
                store.dispatch('addNotification', {
                  type: 'error',
                  message: 'Заполните год',
                });
              })
        } else {
          store.dispatch('addNotification', {
            type: 'error',
            message: 'Заполните год',
          });
        }

      },
      clear() {
        this.category = ''
        this.year = ''
        this.method = ''
        this.metallType = ''
      },
      getCategories () {
        if (this.metallType == 'black') {
          this.getBlackMetallCategories()
        } else {
          this.getColorfullMetallCategories()
        }
        this.category = ''
      },
      getBlackMetallCategories() {
        axios.get('/report/catalogs_is_black/').then(response => {
          // console.log(response)
          let data = response.data.map(({
            name_full: text,
            name: value,
            ...rest
          }) => ({
            text,
            value,
            ...rest
          }))
          this.categories = data
        })
      },
      getColorfullMetallCategories() {
        axios.get('/report/catalogs_is_color/').then(response => {
          let data = response.data.map(({
            name_full: text,
            name: value,
            ...rest
          }) => ({
            text,
            value,
            ...rest
          }))
          this.categories = data
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
.form-select {
  max-height: 40px;
}

.report__pagination {
  padding-top: 1rem;
}

.empty-tr {
  padding: 1rem;
  text-align: center;
  font-size: 1.5rem;
}
</style>
